import React from 'react';
import * as mobxReact from 'mobx-react';
import { FooterLink } from './website-footer-link.presentation';

interface IProps {
    data: FooterLink;
    changeFooterLinkLabel: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    changeFooterLinkUrl: (e?: React.ChangeEvent<HTMLInputElement>) => void;
    getNewFooterLinkUrlValidationError?: string;
    getNewFooterLinkLabelValidationError?: string;
}

export const WebsiteFooterLinkEdit = mobxReact.observer((props: IProps) => {

    return (
        <>
            <div className='flex p-bottom-15px items-center presenters-list'>
                <label className='oe-form-field__title m-right-11px w-100'>
                    Footer Link URL
                    <input
                        type='text'
                        className='oe-form-field__control'
                        placeholder='URL'
                        value={ props.data.url || '' }
                        onChange={e => props.changeFooterLinkUrl(e) }
                    />
                    {props.getNewFooterLinkUrlValidationError && <span className='oe-form-field__error'>{props.getNewFooterLinkUrlValidationError}</span>}
                </label>

                <label className='oe-form-field__title w-100 m-right-24px'>
                    Footer Link Label
                    <input
                        type='text'
                        className='oe-form-field__control'
                        placeholder='Label'
                        value={ props.data.label || '' }
                        onChange={e => props.changeFooterLinkLabel(e)}
                    />
                    {props.getNewFooterLinkLabelValidationError && <span className='oe-form-field__error'>{props.getNewFooterLinkLabelValidationError}</span>}
                </label>
            </div>
        </>
    );
});
